import React, { useState, useEffect } from "react";
import axios from "axios";
// import Cookies from "js-cookie";
import Header from "../Header/Header";
import { Link, useParams } from "react-router-dom";
import { globalLogout } from "../../Utils/Logout";
import Footer from "../../Components/Footer/Footer";
const CategoryPage = () => {
	const { slug } = useParams();
	const [category, setCategory] = useState(null);
	const [subcategories, setSubcategories] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	// Static category data for our special categories
	const staticCategories = {
		delivery: {
			name: "Food Delivery",
			media: "https://images.unsplash.com/photo-1504674900247-0877df9cc836",
			subcategories: [
				{
					id: "restaurants",
					name: "Restaurants",
					media: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4",
				},
				{
					id: "groceries-delivery",
					name: "Groceries Delivery",
					media: "https://images.unsplash.com/photo-1589927986089-35812388d1f4",
				},
			],
		},
		"hotel-flight": {
			name: "Hotel/Flight",
			media: "https://images.unsplash.com/photo-1566073771259-6a8506099945",
			subcategories: [
				{
					id: "hotels",
					name: "Hotels",
					media: "https://images.unsplash.com/photo-1566073771259-6a8506099945",
				},
				{
					id: "flights",
					name: "Flights",
					media: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05",
				},
			],
		},
		service: {
			name: "Service",
			media: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf",
			subcategories: [
				{
					id: "home-services",
					name: "Home Services",
					media: "https://images.unsplash.com/photo-1600566752355-35792bedcfea",
				},
				{
					id: "professional-services",
					name: "Professional Services",
					media: "https://images.unsplash.com/photo-1521791136064-7986c2920216",
				},
			],
		},
		"digital-showroom": {
			name: "Digital Showroom",
			media: "https://images.unsplash.com/photo-1551434678-e076c223a692",
			subcategories: [
				{
					id: "virtual-tours",
					name: "Virtual Tours",
					media: "https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e",
				},
				{
					id: "3d-products",
					name: "3D Products",
					media: "https://images.unsplash.com/photo-1639762681057-408e52192e55",
				},
			],
		},
		laundry: {
			name: "Laundry",
			media: "https://images.unsplash.com/photo-1590071089561-2084f8af8cd1",
			subcategories: [
				{
					id: "wash-fold",
					name: "Wash & Fold",
					media: "https://images.unsplash.com/photo-1604176354204-9268737828e4",
				},
				{
					id: "dry-cleaning",
					name: "Dry Cleaning",
					media: "https://images.unsplash.com/photo-1604176354204-9268737828e4",
				},
			],
		},
	};

	useEffect(() => {
		const fetchCategoryData = async () => {
			try {
				// Check if this is one of our static categories
				if (staticCategories[slug]) {
					setCategory(staticCategories[slug]);
					setSubcategories(staticCategories[slug].subcategories);
					setLoading(false);
					return;
				}

				// const token = Cookies.get("ecom_user_token");
				const response = await axios.get(
					`${process.env.REACT_APP_BACKEND_URL}/api/seller/category/list`,
					// {
					//   headers: {
					//     Authorization: `Bearer ${token}`,
					//   },
					// }
				);

				if (response.data.success) {
					const foundCategory = response.data.categories.find(
						(cat) => cat.slug === slug
					);

					if (foundCategory) {
						setCategory(foundCategory);
						// Get only immediate subcategories (one level deep) and filter published ones
						const immediateSubcategories = (foundCategory.subcategories || [])
							.filter(subcat => subcat.published !== false);
						setSubcategories(immediateSubcategories);
					} else {
						setError("Category not found");
					}
				} else {
					setError("Failed to fetch categories");
				}
			} catch (err) {
				setError(err.message);
				globalLogout(err)
			} finally {
				setLoading(false);
			}
		};

		fetchCategoryData();
	}, [slug]);

	if (loading) {
		return (
			<div className="font-sans bg-gray-100 min-h-screen">
				<Header />
				<div className="flex justify-center items-center h-64">
					<div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500"></div>
				</div>
			</div>
		);
	}

	if (error) {
		return (
			<div className="font-sans bg-gray-100 min-h-screen">
				<Header />
				<div className="flex justify-center items-center h-64">
					<p className="text-red-500 bg-white p-4 rounded shadow">
						Error: {error}
					</p>
				</div>
			</div>
		);
	}

	return (
		<div className="font-sans bg-gray-100 min-h-screen">
			<Header />

			{/* Hero Section */}
			<div
				className="relative w-full bg-cover bg-center h-64"
				style={{
					backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${category.media ||
						"https://images.unsplash.com/photo-1518770660439-4636190af475?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
						})`,
					backgroundPosition: "center",
				}}
			>
				<div className="absolute inset-0 flex items-center justify-center">
					<h1 className="text-white text-4xl font-bold p-4 md:p-0">{category.name}</h1>
				</div>
			</div>

			<div className="container mx-auto p-4 md:p-6">
				<h2 className="text-black font-bold text-2xl mb-6">Shop by Subcategory</h2>
				{subcategories.length > 0 ? (
					<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6">
						{subcategories.map((subcategory) => (
							<Link
								key={subcategory.id}
								to={`/subcategory/${subcategory.slug}`}
								className="bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300 flex flex-col"
							>
								{/* Image container with constrained aspect ratio */}
								<div className="relative w-full pb-[100%] overflow-hidden bg-gray-50">
									<img
										src={subcategory.media || '../../../assets/brand-default.jpg'}
										alt={subcategory.name}
										className="absolute inset-0 w-full h-full object-cover"
										onError={(e) => {
											e.target.src = "../../../assets/brand-default.jpg";
											e.target.className = "absolute inset-0 w-full h-full object-contain p-4";
										}}
									/>
								</div>
								{/* Text content with consistent height */}
								<div className="p-3 text-center min-h-[60px] flex items-center justify-center">
									<span className="font-semibold text-gray-800 line-clamp-2">
										{subcategory.name}
									</span>
								</div>
							</Link>
						))}
					</div>
				) : (
					<div className="bg-white p-6 rounded-lg shadow-sm text-center">
						<p className="text-gray-600">No subcategories available for this category.</p>
					</div>
				)}
			</div>
			<Footer />
		</div>
	);
};

export default CategoryPage;
